import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  const [isAppsDropdownOpen, setIsAppsDropdownOpen] = useState(false);

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">42 Pets</Link>
        <ul className="nav-menu">
          <li className="nav-item">
            <Link to="/" className="nav-link">Home</Link>
          </li>
          <li 
            className="nav-item dropdown"
            onMouseEnter={() => setIsAppsDropdownOpen(true)}
            onMouseLeave={() => setIsAppsDropdownOpen(false)}
          >
            <Link to="/apps" className="nav-link">
              Apps <span className="dropdown-arrow">▼</span>
            </Link>
            {isAppsDropdownOpen && (
              <ul className="dropdown-menu">
                <li><Link to="/apps" className="dropdown-link">All Apps</Link></li>
                <li><Link to="/apps/bartmenu" className="dropdown-link">BartMenu</Link></li>
                <li><Link to="/apps/dishlist" className="dropdown-link">DishList</Link></li>
                <li><Link to="/apps/pawkit" className="dropdown-link">PawKit</Link></li>
              </ul>
            )}
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link">About Us</Link>
          </li>
          <li className="nav-item">
            <Link to="/support" className="nav-link">Support</Link>
          </li>
          <li className="nav-item">
            <Link to="/privacy" className="nav-link">Privacy Policy</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
